/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  FETCH_AG,
  FETCH_AG_SUCCESS,
  FETCH_AG_FAILURE,
  UPDATE_AG,
  UPDATE_AG_SUCCESS,
  UPDATE_AG_FAILURE,
  FETCH_PAG,
  FETCH_PAG_SUCCESS,
  FETCH_PAG_FAILURE,
  UPDATE_PAG,
  UPDATE_PAG_SUCCESS,
  UPDATE_PAG_FAILURE,
} from "./actionTypes";

const automatic_group = (
  state = {
    isFetching: false,
    didInvalidate: false,
    items: [],
    isUpdating: false,
    error: "",

    isPFetching: false,
    didPInvalidate: false,
    preItems: [],
    isPUpdating: false,
    

  },
  action
) => {
  switch (action.type) {
    case FETCH_AG:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false,
      });
    case FETCH_AG_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.automatic_group,
      });
    case FETCH_AG_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: true,
        errorMessage: action.errorMessage,
        items: [],
      });
    case UPDATE_AG:
      return {
        ...state,
        isUpdating: true,
      };
    case UPDATE_AG_SUCCESS:
      return {
        ...state,
        isUpdating: false,
      };
    case UPDATE_AG_FAILURE:
      return {
        ...state,
        isUpdating: false,
        didInvalidate: true,
        errorMessage: action.errorMessage,
      };
      case FETCH_PAG:
      return Object.assign({}, state, {
        isPFetching: true,
        didPInvalidate: false,
        preItems: [],
      });
    case FETCH_PAG_SUCCESS:
      return Object.assign({}, state, {
        isPFetching: false,
        didPInvalidate: false,
        preItems: action.pre_automatic_group,
      });
    case FETCH_PAG_FAILURE:
      return Object.assign({}, state, {
        isPFetching: false,
        didPInvalidate: true,
        preErrorMessage: action.preErrorMessage,
        preItems: [],
      });
    case UPDATE_PAG:
      return {
        ...state,
        isPUpdating: true,
      };
    case UPDATE_PAG_SUCCESS:
      return {
        ...state,
        isPUpdating: false,
      };
    case UPDATE_PAG_FAILURE:
      return {
        ...state,
        isPUpdating: false,
        didPInvalidate: true,
        preErrorMessage: action.preErrorMessage,
      };
    default:
      return state;
  }
};

export default automatic_group;
